<template>

  <div>

    <user-list-add-new
      :is-add-new-user-sidebar-active.sync="isAddNewUserSidebarActive"
      :managers-options="managersOptions"
      
       :contracts-options="contractsOptions"
      @refetch-data="refetchData"
    />

<!--    &lt;!&ndash; Filters &ndash;&gt;-->
<!--    <users-list-filters-->
<!--      :role-filter.sync="roleFilter"-->
<!--      :status-filter.sync="statusFilter"-->
<!--      :role-options="roleOptions"-->
<!--      :status-options="statusOptions"-->
<!--    />-->


    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="loading_page" v-if="requestStatus">
        <orbit-spinner
            :animation-duration="1000"
            :size="100"
            :color="'#0e96b1'"
        />
      </div>

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>{{ $t('Show') }}</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>{{ $t('entries') }}</label>
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
              />
              <b-button v-if="($store.getters['auth/menus'].includes('users.create'))" variant="primary" @click="isAddNewUserSidebarActive = true">
                <span class="text-nowrap">{{ $t('Add User')}}</span>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refUserListTable"
        class="position-relative"
        :items="fetchUsers"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >

        <!-- Column: User -->
        <template #cell(user)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="32"
                :src="data.item.avatar"
                :text="avatarText(data.item.name)"
                :variant="`light-${resolveUserRoleVariant(data.item.role)}`"
                :to="{ name: 'apps-users-view', params: { id: data.item.id } }"
              />
            </template>
            <b-link
              :to="{ name: 'apps-users-view', params: { id: data.item.id } }"
              class="font-weight-bold d-block text-nowrap"
            >
              {{ data.item.name }}
            </b-link>
            <small class="text-muted">@{{ data.item.name }}</small>
          </b-media>
        </template>

        <!-- Column: Role -->
        <template #cell(role)="data">
          <b-badge v-for="role in data.item.roles"  :key="role" style="margin-right: 2px" variant="primary">{{ role }}</b-badge>
        </template>

<!--        &lt;!&ndash; Column: Status &ndash;&gt;-->
<!--        <template #cell(status)="data">-->
<!--          <b-badge-->
<!--            pill-->
<!--            :variant="`light-${resolveUserStatusVariant(data.item.enabled)}`"-->
<!--            class="text-capitalize"-->
<!--          >-->
<!--            {{ data.item.enabled ? $t('Active') : $t('DisActive') }}-->
<!--          </b-badge>-->
<!--        </template>-->

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown class="actionIcon"
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item :to="{ name: 'users.update', params: { id: data.item.id } }">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">{{ $t('Show') }}</span>
            </b-dropdown-item>

<!--            <b-dropdown-item>-->
<!--              <feather-icon icon="TrashIcon" />-->
<!--              <span class="align-middle ml-50">{{ $t('Delete')}}</span>-->
<!--            </b-dropdown-item>-->
          </b-dropdown>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">{{ $t('Showing') }} {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} {{$t('entries')}}</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalUsers"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination,BCardBody, BCardHeader
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import UsersListFilters from './UsersListFilters.vue'
import useUsersList from './useUsersList'
import userStoreModule from '../userStoreModule'
import UserListAddNew from './UserListAddNew.vue'
import { OrbitSpinner } from 'epic-spinners'

export default {
  components: {
    UsersListFilters,
    UserListAddNew,

    OrbitSpinner,

    BCard, BCardHeader, BCardBody,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,

    vSelect,
  },
  setup() {


    const isAddNewUserSidebarActive = ref(false)

    const USER_STORE = 'appUser'

    if (!store.hasModule(USER_STORE)) store.registerModule(USER_STORE, userStoreModule)

    onUnmounted(() => {
      if (store.hasModule(USER_STORE)) store.unregisterModule(USER_STORE)
    })


    const managersOptions = ref([])
    const contractsOptions = ref([])

    const auth = store.getters['auth/user']


    
  store.dispatch('appUser/getManagers', { type: 'user', user: auth.id ,isManager:1})
     .then(res =>{
       managersOptions.value =  res.data.data  
            }
       ).catch(reason => {})

    store.dispatch('appUser/getContracts', { user: auth.id, type: 'contract'})
        .then(res =>  contractsOptions.value = res.data.data)
        .catch(res => console.log(res))


    const statusOptions = [
      { label: 'Active', value: '1' },
      { label: 'Inactive', value: '0' },
    ]

    const {
      fetchUsers,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,
      requestStatus,

        // managersOptions,
        // rolesOptions,

      // Extra Filters
      roleFilter,
      statusFilter,
    } = useUsersList()

    return {

      // Sidebar
      isAddNewUserSidebarActive,
      requestStatus,
      fetchUsers,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // Filter
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      managersOptions,

      // roleOptions,
      statusOptions,
      // managerOptions,
      contractsOptions,

      // Extra Filters
      roleFilter,
      statusFilter,
    }
  },
}
</script>


<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.per-page-selector {
  width: 90px;
}
.actionIcon > button {
  padding: 0;
}
.table > tbody > tr > td {
max-width:200px;

}
</style>
